export default "__VITE_ASSET__BhH3kP5P__"